export default __webpack_public_path__ + "static/media/logo-watermark.99fe414d.svg";